module.exports = __webpack_public_path__ + "static/media/icon_right.0d53131e.svg";